export enum EAvailablePath {
  ACCOUNT = '/account',
  ANALYTICS = '/analytics',
  BOOK_CONFIRMATION_PM = '/book-confirmation/pm',
  BOOK_FOOD_CERTIFICATION = '/book-food-certification',
  BOOK_INSPECTION_CLC = '/book-inspection/clc',
  BOOK_INSPECTION_DUPRO = '/book-inspection/dupro',
  BOOK_INSPECTION_PM = '/book-inspection/pm',
  BOOK_INSPECTION_SP = '/book-inspection/sp',
  // BOOK_INSPECTION_PSI = '/book-inspection/psi',
  BOOKINGS = '/bookings',
  BROKER = '/broker',
  CAP = '/cap',
  CHECKLISTS = '/checklists',
  FACILITIES = '/facilities',
  FIELDS = '/fields',
  HOME = '/home',
  INTERACTIVE_REPORT = '/interactive-report',
  LIFE_SCIENCE = '/life-sciences',
  MULTI_FACTOR_AUTH = '/multi-factor-auth',
  NETWORK = '/network',
  NON_CONFORMANCES = '/non-conformances',
  PAYMENTS = '/payments',
  PAYMENTS_FOR_ACA = '/payments-for-aca',
  PRODUCE_REPORTS = '/produce-reports',
  PRODUCER = '/producer',
  PRODUCERS = '/producers',
  REPORTS = '/reports',
  SHIPPER = '/shipper',
  SHIPPERS = '/shippers',
  SUPPLIER_DOCUMENTS = '/supplier-documents',
  SUPPLIERS = '/suppliers',
}
